import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import Assets from 'presentation/components/SecurePaymentForm/shared/assets';
import { CustomTextContext } from 'context/CustomTextContext';

export default function ExpField(props) {
  const errorOccurred = !props.formState.isValid && !props.formState.isEmpty;
  const { paymentFormExpDateError, paymentFormExpDateLabel, paymentFormExpDatePlaceholder } = useContext(
    CustomTextContext
  );

  useEffect(() => {
    props.form.field('#cc-expiration-date', {
      type: 'card-expiration-date',
      name: 'cardExpirationDate',
      placeholder: paymentFormExpDatePlaceholder,
      yearLength: 2,
      validations: ['required', 'validCardExpirationDate'],
      css: { ...props.cssBase, width: '40%' },
    });
  }, []);

  return (
    <Assets.CollectionFieldEXP isFocused={props.formState.isFocused} shouldShowError={errorOccurred}>
      <Assets.CollectionFieldLabel shouldShowError={errorOccurred}>
        {errorOccurred ? paymentFormExpDateError : paymentFormExpDateLabel}
      </Assets.CollectionFieldLabel>
      <div id="cc-expiration-date" />
    </Assets.CollectionFieldEXP>
  );
}

ExpField.propTypes = {
  cssBase: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
};
